import React, { useState } from "react";
import ArrowBack from "@images/profile/arrow_back.svg";
import RightArrow from "@images/profile/arrow_right.svg";
import UpdownArrow from "@images/profile/swap_vert.svg";
import library from "@images/profile/local_library.svg";
import EmergencyHome from '@images/warning/emergency_home.svg';
import EmergencyHomeWhite from '@images/warning/emergency_home_white.svg';
import ProfileWarning from "./ProfileWarning";
import * as actionTypes from "@redux/actionTypes";
import { useSelector, useDispatch } from "react-redux";
import ProfilePic from '@images/profilePic.png';
import RulesModel from '@components/Modal/RulesModel';
import Modal from "react-modal";
import EditPhotoModel from "./EditPhotoModel";
import { timeZoneAbbreviated } from '@util/config';
import { updateUserAccountData } from '@services/api';
import { toast } from 'react-toastify';

const ProfileSetting = ({ onclick }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.setUserDetails.user)
  const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL
  const ProfilePicture = user?.avatar_url ? `${Bucket_url}${user?.avatar_url}` : ProfilePic;
  const panaltyData = useSelector((state) => state.penalty.panaltyData)
  const rulesOpenModel = useSelector((state) => state.loadingSpinner.ruleModel);

  const [warning, setWarning] = useState("");
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [userName, setUserName] = useState(user.username);
  const [email, setEmail] = useState(user.email);

  const handaleWarning = () => {
    setWarning("warningshow");
  };

  const editPhotoHandler = () => {
    setIsEditOpen(true)
  }

  const closeEditModel = () => {
    setIsEditOpen(false)
  }

  const handleChangeUserName = (event) => {
    setUserName(event.target.value)
  }

  const handleChangeEmail = (event) => {
    setEmail(event.target.value)
  }

  const rulesModelHandler = () => {
    dispatch({
      type: actionTypes.RULES_MODEL,
      payload: true
    });
  };

  const closeRulesModelHandler = () => {
    dispatch({
      type: actionTypes.RULES_MODEL,
      payload: false
    });
  };

  const warningFormatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: 'UTC' };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    return formattedDate.replace(',', '.') + ' ' + timeZoneAbbreviated();
  }

  const formatString = (str) => {
    return str.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  const handleChangeUserNameUpdate = async () => {
    const updateUserProfile = {
      "user": { "username": userName }
    };
    const updateUser = await updateUserAccountData(updateUserProfile)
    if (updateUser && updateUser?.username && updateUser?.username[0]) {
      toast.error('Username has already been taken', { position: "top-right" })
    }
    if (updateUser && updateUser?.user?.username) {
      dispatch({
        type: actionTypes.SET_USER,
        payload: updateUser.user
      })
      setUserName(updateUser.user.username)
      toast.success('Username updated successfully', { position: "top-right" })
    }
  }

  return (
    <div className="w-full">
      {warning === "warningshow" ? (
        <ProfileWarning onclickWarning={() => setWarning()} />
      ) : (
        <div className="w-full">
          <div className="flex justify-between items-center">
            <button
              onClick={onclick}
              className="bg-black px-[12px] text-[16px] lending-[24px] py-[10px] text-white flex gap-[4px] rounded-full"
            >
              {" "}
              <img src={ArrowBack} /> Go back
            </button>
            <div className="flex gap-[16px] mr-[100px]">
              <p className=" text-black font-medium	text-[16px] lending-[24px]">
                Profile
              </p>
              <div>
                {" "}
                <img src={RightArrow} />
              </div>
              <p className="text-black font-medium text-[16px] lending-[24px]">
                Settings
              </p>
            </div>
            <div />
          </div>
          <div className="max-w-[512px] mx-auto lg:mt-14 md:mt-[32px] mt-[16px]">
            <h4 className="text-black lg:text-[42px] lg:leading-[42px] md:text-[36px] md:leading-[40px] text-[30px] leading-[36px] font-semibold text-center">
              Settings
            </h4>
            <div className="py-[32px] flex flex-col gap-[24px]">
              <p className="text-black font-semibold text-[24px] leading-[32px]">General</p>
              <div className="grid grid-cols-4 gap-[32px]">
                <div className="flex flex-col gap-[8px]">
                  <div>
                    <img src={ProfilePicture} className="rounded-full w-[96px] h-[96px]" />
                  </div>
                  <button className="text-center underline text-black text-[14px] leading-[20px] cursor-pointer font-medium" onClick={editPhotoHandler}>
                    Edit Photo
                  </button>
                </div>
                <div className="col-span-3 flex flex-col gap-[8px]">
                  <div>
                    <label className="text-[14px] leading-[20px] text-black py-[4px]">Name</label>
                    <div className="flex items-center bg-white rounded-lg pr-[16px]">
                      <input
                        type="text"
                        id="cardholderName"
                        placeholder="Enter your name"
                        value={userName}
                        onChange={handleChangeUserName}
                        className="py-[10px] px-[16px] w-full rounded-lg bg-white focus:focus-visible:outline-none text-black placeholder:text-black focus:text-black"
                      />
                      <button onClick={handleChangeUserNameUpdate}>
                        <p className="text-green text-[16px] lending-[24px] font-semibold flex gap-[4px]">
                          <span className="w-[16px]">
                            <img src={UpdownArrow} />
                          </span>{" "}
                          Change
                        </p>
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="text-[14px] leading-[20px] text-black py-[4px]">
                      Discord Connection
                    </label>
                    <div className="flex items-center bg-white rounded-lg  px-[16px]">
                      <input
                        type="text"
                        id="cardholderName"
                        placeholder="Enter your email"
                        value={email}
                        onChange={handleChangeEmail}
                        className="py-[10px] w-full rounded-none bg-transparent focus:focus-visible:outline-none text-black placeholder:text-black focus:text-black"
                      />
                      {/* <button>
                        <p className="text-green text-[16px] lending-[24px] font-semibold flex gap-[4px]">
                          <span className="w-[16px]">
                            <img src={UpdownArrow} />
                          </span>{" "}
                          Change
                        </p>
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="border-gray-500" />
            </div>
            <div className="flex gap-[20px] flex-col">
              <p className="text-black font-semibold text-[24px] leading-[32px]">Warnings</p>
              <p className="text-[#737373] text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]">
                Be aware that accounts receive only two warnings before
                permanent ban. You can appeal these warnings. They're issued for
                significant disruption caused by the FrodoBot, for which the
                driver is responsible.
              </p>
              <button className="w-[230px] flex pl-[8px] pr-[12px] py-[6px] items-start gap-[6px] rounded-[1000px] border-[1px] border-[solid] border-[#737373] bg-[#000]" onClick={rulesModelHandler}>
                <div className="w-[20px] h-[20px]">
                  <img src={library} />
                </div>
                <p className="text-[#FAFAFA] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]">
                  Learn more about rules
                </p>
              </button>
              {panaltyData?.length > 0 && panaltyData.map((item, index) => (
                <div
                  key={index}
                  className={`${item.penalty_reason.severity === 'major' ? 'bg-[#FF1053]' : 'bg-[#FFB648]'} flex p-[16px] flex-col items-start gap-[16px] rounded-[16px]`}
                >
                  <div className="flex flex-col justify-center items-start gap-[8px]">
                    <div className="flex items-center gap-[8px]">
                      {item.penalty_reason.severity === 'major' ?
                        <img
                          src={EmergencyHomeWhite}
                          alt="emergencyHome-img" />
                        :
                        <img
                          src={EmergencyHome}
                          alt="emergencyHome-img"
                        />
                      }
                      <p className={`text-[#FAFAFA] text-[18px] leading-[28px] font-medium`}>
                        {index + 1}nd Warning
                      </p>
                    </div>
                    <p className={` ${item.penalty_reason.severity === 'major' ? 'text-[#FAFAFA]' : 'text-[#000]'} text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]`}>
                      {warningFormatDate(item.created_at)} at FrodoBots Alpha, Mission: {item.mission_id}
                    </p>
                    <p className={` ${item.penalty_reason.severity === 'major' ? 'text-[#FAFAFA]' : 'text-[#000]'} text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]`}>
                      Reason: {formatString(item.penalty_reason.name)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )
      }
      <Modal
        isOpen={isEditOpen}
        ariaHideApp={false}
        className="mymodal"
        onRequestClose={closeEditModel}
      >
        <EditPhotoModel setIsEditOpen={setIsEditOpen} />
      </Modal>
      <Modal
        isOpen={rulesOpenModel}
        ariaHideApp={false}
        className="absolute top-2/4 left-2/4 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] bg-[#FAFAFA]"
        onRequestClose={closeRulesModelHandler}
      >
        <RulesModel closeRulesModelHandler={closeRulesModelHandler} />
      </Modal>
    </div >
  );
};

export default ProfileSetting;
